/** Merge notification API `data` and `deepLink` maps (same rules as mobile AppNotification handling). */
export function mergeNotificationPayload(notification) {
  const raw = notification && typeof notification === "object" ? notification : {};
  const data =
    raw.data && typeof raw.data === "object" && !Array.isArray(raw.data)
      ? raw.data
      : {};
  const deepLink =
    raw.deepLink &&
    typeof raw.deepLink === "object" &&
    !Array.isArray(raw.deepLink)
      ? raw.deepLink
      : {};
  const merged = { ...data, ...deepLink };
  // Some APIs put deep-link ids on the root of the notification object
  if (raw.conversationId != null) merged.conversationId = raw.conversationId;
  if (raw.conversation_id != null)
    merged.conversationId = raw.conversation_id;
  return merged;
}

export function normalizeNotificationsResponse(body) {
  if (body == null) return [];
  if (Array.isArray(body)) return body;
  if (typeof body === "object") {
    if (Array.isArray(body.items)) return body.items;
    if (Array.isArray(body.notifications)) return body.notifications;
  }
  return [];
}
